/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  SafeAreaView,
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  Image,
  FlatList,
  RefreshControl,
  Alert,
  Dimensions,
} from 'react-native';
import { Ionicons, MaterialCommunityIcons } from '@expo/vector-icons';

const { width } = Dimensions.get('window');

// JOBENG Logo component using the app icon
const CompanyLogo = ({ uri, size = 32 }) => {
  if (uri) {
    return (
      <Image
        source={{ uri }}
        style={{ width: size, height: size, borderRadius: 6 }}
        resizeMode="contain"
      />
    );
  }
  return (
    <View style={{ width: size, height: size, borderRadius: 6, backgroundColor: 'rgba(255,255,255,0.2)', alignItems: 'center', justifyContent: 'center' }}>
      <MaterialCommunityIcons name="office-building" size={size * 0.6} color="#fff" />
    </View>
  );
};

const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const getH = async () => { const tok = await AsyncStorage.getItem('auth_token').catch(()=>null); return { 'Content-Type':'application/json','x-api-key':API_KEY, ...(tok?{Authorization:`Bearer ${tok}`}:{}) }; };

const NotificationHistoryScreen = ({ navigation }) => {
  const [companyLogo, setCompanyLogo] = useState(null);

  useEffect(() => {
    AsyncStorage.getItem('company_profile').then(raw => {
      if (!raw) return;
      try {
        const p = JSON.parse(raw);
        const logo = p.logo || p.logo_url || p.company_logo || p.banner_image_url;
        if (logo) setCompanyLogo(logo.startsWith('http') || logo.startsWith('data:') ? logo : `https://api.jobeng.ai${logo}`);
      } catch {}
    }).catch(() => {});
  }, []);

  const [notifications, setNotifications] = useState([]);
  const [filteredNotifications, setFilteredNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [activeFilter, setActiveFilter] = useState('All');
  const [selectedPeriod, setSelectedPeriod] = useState('Last 30 Days');

  // Mock historical notifications data
  const mockHistoricalNotifications = [
    {
      id: 'h1',
      type: 'campaign_performance',
      title: 'Campaign Performance Alert',
      message:
        'Summer Engineering Expo campaign has exceeded its target engagement rate by 15%',
      timestamp: '2025-06-11T10:30:00Z',
      isRead: true,
      priority: 'high',
      campaignId: 'c1',
      campaignName: 'Summer Engineering Expo',
      actionTaken: 'Viewed',
      icon: 'trending-up',
      iconColor: '#28a745',
    },
    {
      id: 'h2',
      type: 'budget_alert',
      title: 'Budget Threshold Reached',
      message:
        'Civil Engineering Recruitment campaign has used 80% of its allocated budget',
      timestamp: '2025-06-11T09:15:00Z',
      isRead: true,
      priority: 'medium',
      campaignId: 'c2',
      campaignName: 'Civil Engineering Recruitment',
      actionTaken: 'Budget Adjusted',
      icon: 'currency-gbp',
      iconColor: '#ffc107',
    },
    {
      id: 'h3',
      type: 'campaign_status',
      title: 'Campaign Scheduled',
      message: 'Engineering Webinar Series is scheduled to start in 3 days',
      timestamp: '2025-06-10T08:45:00Z',
      isRead: true,
      priority: 'low',
      campaignId: 'c3',
      campaignName: 'Engineering Webinar Series',
      actionTaken: 'Acknowledged',
      icon: 'calendar-clock',
      iconColor: '#0e4e96',
    },
    {
      id: 'h4',
      type: 'system_update',
      title: 'New Analytics Features',
      message:
        'Enhanced audience insights and demographic breakdowns are now available',
      timestamp: '2025-06-09T16:20:00Z',
      isRead: true,
      priority: 'low',
      campaignId: null,
      campaignName: null,
      actionTaken: 'Explored Features',
      icon: 'chart-line',
      iconColor: '#17a2b8',
    },
    {
      id: 'h5',
      type: 'campaign_completion',
      title: 'Campaign Completed',
      message:
        'Spring Recruitment Drive has successfully completed with 18,600+ reach',
      timestamp: '2025-06-08T14:30:00Z',
      isRead: true,
      priority: 'medium',
      campaignId: 'c4',
      campaignName: 'Spring Recruitment Drive',
      actionTaken: 'Report Downloaded',
      icon: 'check-circle',
      iconColor: '#28a745',
    },
    {
      id: 'h6',
      type: 'asset_approval',
      title: 'Asset Approved',
      message: 'Banner design for Summer Engineering Expo has been approved',
      timestamp: '2025-06-07T11:15:00Z',
      isRead: true,
      priority: 'high',
      campaignId: 'c1',
      campaignName: 'Summer Engineering Expo',
      actionTaken: 'Approved',
      icon: 'image-outline',
      iconColor: '#28a745',
    },
    {
      id: 'h7',
      type: 'budget_alert',
      title: 'Budget Warning',
      message:
        'Summer Engineering Expo campaign has used 60% of its allocated budget',
      timestamp: '2025-06-06T13:20:00Z',
      isRead: true,
      priority: 'medium',
      campaignId: 'c1',
      campaignName: 'Summer Engineering Expo',
      actionTaken: 'Monitored',
      icon: 'currency-gbp',
      iconColor: '#ffc107',
    },
    {
      id: 'h8',
      type: 'audience_insight',
      title: 'Weekly Audience Report',
      message: 'Your weekly audience insights report is ready for review',
      timestamp: '2025-06-05T09:00:00Z',
      isRead: true,
      priority: 'low',
      campaignId: null,
      campaignName: null,
      actionTaken: 'Report Viewed',
      icon: 'account-group',
      iconColor: '#6f42c1',
    },
    {
      id: 'h9',
      type: 'campaign_performance',
      title: 'Milestone Reached',
      message:
        'Civil Engineering Recruitment campaign reached 10,000 impressions',
      timestamp: '2025-06-04T15:45:00Z',
      isRead: true,
      priority: 'medium',
      campaignId: 'c2',
      campaignName: 'Civil Engineering Recruitment',
      actionTaken: 'Celebrated',
      icon: 'trophy',
      iconColor: '#ffd700',
    },
    {
      id: 'h10',
      type: 'security',
      title: 'Login from New Device',
      message: 'Your account was accessed from a new device in London',
      timestamp: '2025-06-03T18:30:00Z',
      isRead: true,
      priority: 'high',
      campaignId: null,
      campaignName: null,
      actionTaken: 'Verified',
      icon: 'shield-check',
      iconColor: '#dc3545',
    },
  ];

  const filterOptions = [
    { id: 'All', name: 'All', icon: 'bell' },
    { id: 'Campaign', name: 'Campaigns', icon: 'bullhorn' },
    { id: 'System', name: 'System', icon: 'cog' },
    { id: 'Security', name: 'Security', icon: 'shield-check' },
    { id: 'High Priority', name: 'High Priority', icon: 'alert-circle' },
  ];

  const periodOptions = [
    { id: 'Last 7 Days', name: 'Last 7 Days' },
    { id: 'Last 30 Days', name: 'Last 30 Days' },
    { id: 'Last 3 Months', name: 'Last 3 Months' },
    { id: 'Last 6 Months', name: 'Last 6 Months' },
    { id: 'All Time', name: 'All Time' },
  ];

  useEffect(() => {
    loadNotificationHistory();
  }, []);

  useEffect(() => {
    filterNotifications();
  }, [notifications, activeFilter, selectedPeriod]);

  const loadNotificationHistory = async () => {
    setLoading(true);
    try {
      const h = await getH();
      const bid = await AsyncStorage.getItem('company_id').catch(()=>null);
      const params = new URLSearchParams({
        company_id: parseInt(bid)||0,
        limit: 100,
        period: selectedPeriod === 'Last 7 Days' ? '7d' : selectedPeriod === 'Last 30 Days' ? '30d' : selectedPeriod === 'Last 90 Days' ? '90d' : 'all',
      });
      const res = await fetch(`${API_BASE}/api/data/campaign_notifications?${params}`, { headers: h });
      const json = await res.json().catch(()=>({}));
      const data = Array.isArray(json?.data) ? json.data : [];
      if (data.length) {
        const mapped = data.map(n => ({
          id: n.id, type: n.notification_type||n.type||'system_update',
          title: n.title, message: n.message||n.body||'',
          timestamp: n.created_at||n.timestamp, isRead: n.is_read||n.isRead||false,
          priority: n.priority||'low', campaignId: n.campaign_id||n.campaignId,
          campaignName: n.campaign_name||n.campaignName,
          actionRequired: n.action_required||n.actionRequired||false,
          icon: n.icon||'bell-outline', iconColor: n.icon_color||n.iconColor||'#0e4e96',
        }));
        setNotifications(mapped);
        setFilteredNotifications(mapped);
        setLoading(false); setRefreshing(false);
        return;
      }
    } catch(e) { console.warn('[NotifHistory]', e.message); }
    setNotifications([]);
    setFilteredNotifications([]);
    setLoading(false); setRefreshing(false);
  };


  const onRefresh = async () => {
    setRefreshing(true);
    setTimeout(() => {
      loadNotificationHistory();
      setRefreshing(false);
    }, 1500);
  };

  const filterNotifications = () => {
    let filtered = notifications;

    // Filter by type
    switch (activeFilter) {
      case 'Campaign':
        filtered = notifications.filter(n =>
          [
            'campaign_performance',
            'campaign_status',
            'campaign_completion',
            'budget_alert',
            'asset_approval',
          ].includes(n.type)
        );
        break;
      case 'System':
        filtered = notifications.filter(n =>
          ['system_update', 'audience_insight'].includes(n.type)
        );
        break;
      case 'Security':
        filtered = notifications.filter(n => n.type === 'security');
        break;
      case 'High Priority':
        filtered = notifications.filter(n => n.priority === 'high');
        break;
      default:
        filtered = notifications;
    }

    // Filter by time period
    const now = new Date();
    const filterDate = new Date();

    switch (selectedPeriod) {
      case 'Last 7 Days':
        filterDate.setDate(now.getDate() - 7);
        break;
      case 'Last 30 Days':
        filterDate.setDate(now.getDate() - 30);
        break;
      case 'Last 3 Months':
        filterDate.setMonth(now.getMonth() - 3);
        break;
      case 'Last 6 Months':
        filterDate.setMonth(now.getMonth() - 6);
        break;
      default:
        filterDate.setFullYear(2000); // Show all
    }

    filtered = filtered.filter(n => new Date(n.timestamp) >= filterDate);

    setFilteredNotifications(filtered);
  };

  const handlePeriodSelection = () => {
    Alert.alert(
      'Select Time Period',
      'Choose the time period to view:',
      periodOptions
        .map(period => ({
          text: period.name,
          onPress: () => setSelectedPeriod(period.id),
        }))
        .concat([{ text: 'Cancel', style: 'cancel' }])
    );
  };

  const handleExportHistory = () => {
    Alert.alert('Export History', 'Export your notification history as:', [
      { text: 'CSV File', onPress: () => Alert.alert('Export CSV', 'Notification history exported as CSV.') },
      { text: 'PDF Report', onPress: () => Alert.alert('Export PDF', 'Notification history exported as PDF.') },
      { text: 'Cancel', style: 'cancel' },
    ]);
  };

  const handleClearHistory = () => {
    Alert.alert(
      'Clear History',
      'Are you sure you want to clear your notification history? This action cannot be undone.',
      [
        { text: 'Cancel', style: 'cancel' },
        {
          text: 'Clear',
          style: 'destructive',
          onPress: () => {
            setNotifications([]);
            Alert.alert(
              'History Cleared',
              'Your notification history has been cleared.'
            );
          },
        },
      ]
    );
  };

  const formatTimestamp = timestamp => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));

    if (diffInHours < 24) {
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
    } else if (diffInHours < 168) {
      // Less than a week
      const diffInDays = Math.floor(diffInHours / 24);
      return `${diffInDays}d ago`;
    } else {
      return date.toLocaleDateString();
    }
  };

  const getPriorityColor = priority => {
    switch (priority) {
      case 'high':
        return '#dc3545';
      case 'medium':
        return '#ffc107';
      case 'low':
        return '#28a745';
      default:
        return '#6c757d';
    }
  };

  const getActionStatusColor = actionTaken => {
    if (!actionTaken || actionTaken === 'None') return '#6c757d';
    return '#28a745';
  };

  const renderNotificationItem = ({ item }) => (
    <View style={styles.notificationCard}>
      <View style={styles.notificationHeader}>
        <View style={styles.notificationIcon}>
          <MaterialCommunityIcons
            name={item.icon}
            size={24}
            color={item.iconColor}
          />
        </View>
        <View style={styles.notificationContent}>
          <View style={styles.notificationTitleRow}>
            <Text style={styles.notificationTitle}>{item.title}</Text>
            <View style={styles.notificationMeta}>
              <View
                style={[
                  styles.priorityIndicator,
                  { backgroundColor: getPriorityColor(item.priority) },
                ]}
              />
              <Text style={styles.notificationTime}>
                {formatTimestamp(item.timestamp)}
              </Text>
            </View>
          </View>
          <Text style={styles.notificationMessage}>{item.message}</Text>
          <View style={styles.notificationFooter}>
            <View style={styles.notificationTags}>
              {item.campaignName && (
                <View style={styles.campaignTag}>
                  <Text style={styles.campaignTagText}>
                    {item.campaignName}
                  </Text>
                </View>
              )}
              <View
                style={[
                  styles.actionTag,
                  { backgroundColor: getActionStatusColor(item.actionTaken) },
                ]}
              >
                <Text style={styles.actionTagText}>
                  {item.actionTaken || 'No Action'}
                </Text>
              </View>
            </View>
            <Text style={styles.fullTimestamp}>
              {new Date(item.timestamp).toLocaleString()}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );

  const renderEmptyState = () => (
    <View style={styles.emptyContainer}>
      <MaterialCommunityIcons name="history" size={60} color="#ccc" />
      <Text style={styles.emptyTitle}>No notification history</Text>
      <Text style={styles.emptySubtitle}>
        {activeFilter === 'All'
          ? 'Your notification history will appear here.'
          : `No ${activeFilter.toLowerCase()} notifications found for the selected period.`}
      </Text>
    </View>
  );

  const renderStatsCard = () => {
    const totalNotifications = filteredNotifications.length;
    const highPriorityCount = filteredNotifications.filter(
      n => n.priority === 'high'
    ).length;
    const actionTakenCount = filteredNotifications.filter(
      n => n.actionTaken && n.actionTaken !== 'None'
    ).length;
    const campaignNotifications = filteredNotifications.filter(
      n => n.campaignId
    ).length;

    return (
      <View style={styles.statsContainer}>
        <Text style={styles.statsTitle}>Summary</Text>
        <View style={styles.statsGrid}>
          <View style={styles.statCard}>
            <Text style={styles.statValue}>{totalNotifications}</Text>
            <Text style={styles.statLabel}>Total</Text>
          </View>
          <View style={styles.statCard}>
            <Text style={[styles.statValue, { color: '#dc3545' }]}>
              {highPriorityCount}
            </Text>
            <Text style={styles.statLabel}>High Priority</Text>
          </View>
          <View style={styles.statCard}>
            <Text style={[styles.statValue, { color: '#28a745' }]}>
              {actionTakenCount}
            </Text>
            <Text style={styles.statLabel}>Acted Upon</Text>
          </View>
          <View style={styles.statCard}>
            <Text style={[styles.statValue, { color: '#0e4e96' }]}>
              {campaignNotifications}
            </Text>
            <Text style={styles.statLabel}>Campaign</Text>
          </View>
        </View>
      </View>
    );
  };

  return (
    <SafeAreaView style={styles.container}>
      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Ionicons name="arrow-back" size={24} color="#fff" />
        </TouchableOpacity>
        <CompanyLogo uri={companyLogo} size={30} />
        <TouchableOpacity onPress={handleExportHistory}>
          <MaterialCommunityIcons name="download" size={24} color="#fff" />
        </TouchableOpacity>
      </View>

      {/* Title and Controls */}
      <View style={styles.titleContainer}>
        <Text style={styles.screenTitle}>Notification History</Text>
        <View style={styles.controlsRow}>
          <TouchableOpacity
            style={styles.periodSelector}
            onPress={handlePeriodSelection}
          >
            <Text style={styles.periodText}>{selectedPeriod}</Text>
            <MaterialCommunityIcons
              name="chevron-down"
              size={20}
              color="#666"
            />
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.clearButton}
            onPress={handleClearHistory}
          >
            <MaterialCommunityIcons
              name="delete-outline"
              size={20}
              color="#dc3545"
            />
            <Text style={styles.clearButtonText}>Clear</Text>
          </TouchableOpacity>
        </View>
      </View>

      {/* Filter Tabs */}
      <View style={styles.filterContainer}>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          style={styles.filterScroll}
        >
          {filterOptions.map(filter => (
            <TouchableOpacity
              key={filter.id}
              style={[
                styles.filterButton,
                activeFilter === filter.id && styles.activeFilterButton,
              ]}
              onPress={() => setActiveFilter(filter.id)}
            >
              <MaterialCommunityIcons
                name={filter.icon}
                size={16}
                color={activeFilter === filter.id ? '#0e4e96' : '#666'}
              />
              <Text
                style={[
                  styles.filterText,
                  activeFilter === filter.id && styles.activeFilterText,
                ]}
              >
                {filter.name}
              </Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>

      {/* Stats Summary */}
      {filteredNotifications.length > 0 && renderStatsCard()}

      {/* Notifications List */}
      <FlatList
        data={filteredNotifications}
        renderItem={renderNotificationItem}
        keyExtractor={item => item.id}
        contentContainerStyle={styles.listContainer}
        refreshControl={
          <RefreshControl
            refreshing={refreshing}
            onRefresh={onRefresh}
            colors={['#0e4e96']}
            tintColor="#0e4e96"
          />
        }
        ListEmptyComponent={renderEmptyState}
        showsVerticalScrollIndicator={false}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f7fa',
  },
  header: {
    backgroundColor: '#0e4e96',
    paddingVertical: 15,
    paddingHorizontal: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleContainer: {
    backgroundColor: '#fff',
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#e1e1e1',
  },
  screenTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 15,
  },
  controlsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  periodSelector: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f8f9fa',
    paddingHorizontal: 15,
    paddingVertical: 8,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: '#e1e1e1',
  },
  periodText: {
    fontSize: 14,
    color: '#333',
    marginRight: 5,
  },
  clearButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 15,
    paddingVertical: 8,
  },
  clearButtonText: {
    fontSize: 14,
    color: '#dc3545',
    marginLeft: 5,
  },
  filterContainer: {
    backgroundColor: '#fff',
    borderBottomWidth: 1,
    borderBottomColor: '#e1e1e1',
  },
  filterScroll: {
    paddingHorizontal: 10,
  },
  filterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 15,
    marginHorizontal: 5,
  },
  activeFilterButton: {
    borderBottomWidth: 2,
    borderBottomColor: '#0e4e96',
  },
  filterText: {
    color: '#666',
    fontWeight: '500',
    marginLeft: 5,
  },
  activeFilterText: {
    color: '#0e4e96',
    fontWeight: 'bold',
  },
  statsContainer: {
    backgroundColor: '#fff',
    margin: 15,
    borderRadius: 8,
    padding: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
  },
  statsTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 15,
  },
  statsGrid: {
    flexDirection: 'row',
    gap: 10,
  },
  statCard: {
    flex: 1,
    backgroundColor: '#f8f9fa',
    padding: 15,
    borderRadius: 8,
    alignItems: 'center',
  },
  statValue: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 5,
  },
  statLabel: {
    fontSize: 12,
    color: '#666',
    textAlign: 'center',
  },
  listContainer: {
    padding: 15,
    paddingTop: 0,
    flexGrow: 1,
  },
  notificationCard: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 15,
    marginBottom: 10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
  },
  notificationHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  notificationIcon: {
    marginRight: 12,
    marginTop: 2,
  },
  notificationContent: {
    flex: 1,
  },
  notificationTitleRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 5,
  },
  notificationTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    flex: 1,
    marginRight: 10,
  },
  notificationMeta: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  priorityIndicator: {
    width: 8,
    height: 8,
    borderRadius: 4,
    marginRight: 8,
  },
  notificationTime: {
    fontSize: 12,
    color: '#999',
  },
  notificationMessage: {
    fontSize: 14,
    color: '#666',
    lineHeight: 20,
    marginBottom: 10,
  },
  notificationFooter: {
    gap: 8,
  },
  notificationTags: {
    flexDirection: 'row',
    gap: 8,
  },
  campaignTag: {
    backgroundColor: '#e0f2ff',
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 10,
  },
  campaignTagText: {
    fontSize: 12,
    color: '#0e4e96',
  },
  actionTag: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 10,
  },
  actionTagText: {
    fontSize: 12,
    color: '#fff',
    fontWeight: '500',
  },
  fullTimestamp: {
    fontSize: 11,
    color: '#999',
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 60,
  },
  emptyTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#666',
    marginTop: 15,
    marginBottom: 5,
  },
  emptySubtitle: {
    fontSize: 14,
    color: '#999',
    textAlign: 'center',
    lineHeight: 20,
    paddingHorizontal: 40,
  },
});

export default NotificationHistoryScreen;
